<template>
  <div>
    <detail-fail
      v-if="dataNotFound"
      @toHomePage="toHomePage"
      :lostData="lostData"
      :isWeixin="isWeixin"
      :isMobile="isMobile"
      :isInApp="isInApp"
    />
    <main class="all" v-if="info" aria-labelledby="activity-title">
      <div
        v-if="info.is_audit === 1 && info.is_vip === 0"
        class="censor-box censor-box-audit"
      >
        <div class="bg-white" v-if="info.is_owner">
          <img
            class="verifying_icon"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/445a8a9c2ce41c9c66c3939ae5351df5.svg"
            alt="审核中"
          />
          <div class="verifying-title">审核中</div>
          <div class="censor-desc audit_desc">
            <div>
              工作日10:00-19:00
              两小时内完成审核，周末/节假日时间不定。审核期间可继续编辑修改
            </div>
          </div>
          <div class="aduitBtnGroup" v-if="!info.enterprise_vip">
            <button class="btn-blue buy-btn" @click="auditClick">
              升级高级版，极速审核
            </button>
          </div>
          <div class="aduitBtnGroup">
            <button class="single-btn pointer" @click="showManage">
              修改设置
            </button>
            <button class="single-btn ml30 pointer" @click="showManage">
              编辑题目
            </button>
            <button class="single-btn ml30 pointer" @click="showManage">
              接收审核通知
            </button>
          </div>
        </div>
        <div v-else>
          <div class="bg-white">
            <img class="verifying_icon" :src="verifyingIcon" alt="审核中" />
            <div class="censor-title">此答题内容审核中...</div>
            <div class="censor-desc">
              暂时无法查看，请等待审核通过后再进入参与
            </div>
            <div class="aduit_service" @click="toIndexPage">返回首页</div>
          </div>
          <div v-if="!info.enterprise_vip || info.owner_vip">
            <Ad v-if="!isInApp" :isWeixin="isWeixin" :isMobile="isMobile" />
          </div>
        </div>
        <div
          open-type="contact"
          @click="handleContact(0)"
          class="audit-service"
        >
          联系客服
        </div>
      </div>
      <div
        v-else-if="info.is_violation === 1 && info.is_vip === 0"
        class="censor-box censor-box-audit "
      >
        <div class="bg-white">
          <img class="verifying_icon" :src="violationIcon" alt="违规内容" />
          <div class="censor-title">此答题内容违规</div>
          <div class="censor-desc">
            {{
              info.is_owner
                ? "答题内含有违规内容，无法进行查看与使用，如有问题请联系客服协助处理。"
                : "暂时无法查看，请等待处理后再参与"
            }}
          </div>
          <div
            v-if="info.is_owner"
            open-type="contact"
            @click="handleContact(0)"
            class="aduit_service"
          >
            联系客服
          </div>
          <div v-else class="aduit_service" @click="toIndexPage">
            返回首页
          </div>
        </div>
        <div v-if="!info.enterprise_vip || info.owner_vip">
          <Ad v-if="!isInApp" :isWeixin="isWeixin" :isMobile="isMobile" />
        </div>
      </div>
      <div
        v-else-if="info.is_violation === 2 && info.is_vip === 0"
        class="censor-box censor-box-audit "
      >
        <div class="bg-white">
          <img class="verifying_icon" :src="violationIcon" alt="有争议内容" />
          <div class="censor-title">答题存在有争议的内容</div>
          <div class="censor-desc censor-desc-pre">
            {{
              !info.is_owner || !info.dispute
                ? "请耐心等待有争议内容协商解决"
                : info.dispute
            }}
          </div>
          <div
            v-if="info.is_owner"
            @click="handleContact(0)"
            class="aduit_service"
          >
            联系客服
          </div>
          <div v-else class="aduit_service" @click="toIndexPage">
            返回首页
          </div>
        </div>
        <div v-if="!info.enterprise_vip || info.owner_vip">
          <Ad v-if="!isInApp" :isWeixin="isWeixin" :isMobile="isMobile" />
        </div>
      </div>
      <template v-else>
        <img
          v-if="info.banner"
          class="banner"
          :src="info.banner"
          @click="previewImage(info.banner)"
          alt=""
        />
        <article class="main">
          <section class="work-content">
            <header>
              <h1 id="activity-title" class="content-top-title">
                {{ info.title }}
              </h1>
              <div class="tag-box">
              <template>
                <div
                  v-if="
                    info.is_violation == 1 ||
                      info.is_violation == 2 ||
                      info.is_audit
                  "
                  class="tag-item red"
                >
                  {{
                    info.is_audit == 1
                      ? "审核中"
                      : info.is_violation == 1
                      ? "违规"
                      : "争议"
                  }}
                </div>
                <div class="tag-item red" v-if="info.award_type > 0">
                  <img
                    class="award-icon"
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-22/94fd1fa627f56860df9e625acde87a18.png"
                  />有奖
                </div>
                <div
                  v-if="
                    info.is_violation != 1 &&
                      info.is_violation != 2 &&
                      info.is_audit == 0
                  "
                  :class="info.status == 1 ? 'tag-item ' : 'gray tag-item '"
                >
                  {{ status_text }}
                </div>
                <div
                  @click="tagTip(info.total_join_limit > -1 ? 2 : 0)"
                  v-if="info.temp == 2 || info.total_join_limit_empty"
                  :class="
                    (info.joined_limit > -1 &&
                      info.joined >= info.joined_limit) ||
                    (info.total_join_limit > -1 &&
                      info.total_join >= info.total_join_limit)
                      ? 'red tag-item'
                      : 'tag-item'
                  "
                >
                  <img
                    class="tag-icon"
                    :src="
                      (info.joined_limit > -1 &&
                        info.joined >= info.joined_limit) ||
                      (info.total_join_limit > -1 &&
                        info.total_join >= info.total_join_limit)
                        ? countIcon[0]
                        : countIcon[1]
                    "
                  /><span>{{info.total_join_limit > -1 ? transNumWan(info.total_join) : transNumWan(info.joined) }}/</span
                  >{{
                    info.total_join_limit > -1
                      ? transNumWan(info.total_join_limit) + "次"
                      : info.joined_limit > -1
                      ? transNumWan(info.joined_limit)
                      : "人数无限制"
                  }}{{
                    info.total_join_limit > -1 &&
                    info.total_join >= info.total_join_limit
                      ? "已达上限"
                      : info.joined_limit > -1 &&
                        info.joined >= info.joined_limit
                      ? "已达上限"
                      : ""
                  }}
                </div>
                <!--  -->
                <div
                  @click="tagTip(2)"
                  v-else
                  :class="
                    info.total_join_limit > -1 &&
                    info.total_join >= info.total_join_limit
                      ? 'red tag-item'
                      : 'tag-item'
                  "
                >
                  <img
                    class="tag-icon"
                    :src="
                      info.total_join_limit > -1 &&
                      info.total_join >= info.total_join_limit
                        ? countIcon[0]
                        : countIcon[1]
                    "
                  /><span>{{ transNumWan(info.total_join) }}/</span
                  >{{
                    info.total_join_limit > -1
                      ? transNumWan(info.total_join_limit) + "次"
                      : "无限制"
                  }}{{
                    info.total_join_limit > -1 &&
                    info.total_join >= info.total_join_limit
                      ? "已达上限"
                      : ""
                  }}
                </div>
              </template>
                <div
                  class="tag-item"
                  v-if="info.anti_cheating"
                  @click="tagTip(1)"
                >
                  <img
                  src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220825/2022-08-25/399edc236ca3078e37339cdd706b7c8b.svg"
                  class="tag-icon"
                />防作弊已开启
                </div>
              </div>
            </header>
            <section class="rules-box" aria-label="答题规则">
              <div class="rules-top">
                <div class="rules_top_item">
                  <div class="rules_top_item_title">
                    题数
                  </div>
                  <div class="rules_top_item_text">{{ info.ques_number }}</div>
                </div>
                <div class="rules_top_item" v-if="info.temp != 3">
                  <div class="rules_top_item_title">总分</div>
                  <div class="rules_top_item_text">{{ info.full_score }}</div>
                </div>
                <div class="rules_top_item">
                  <div class="rules_top_item_title">限时</div>
                  <div
                    :class="
                      info.time_limit
                        ? 'rules_top_item_text'
                        : 'f30 rules_top_item_text'
                    "
                  >
                    <template v-if="info.time_limit">
                      {{ info.time_limit }}<span class="sec-desc">分钟</span>
                    </template>
                    <span v-else>无限制</span>
                  </div>
                </div>
                <div class="rules_top_item">
                  <div class="rules_top_item_title">
                    剩余次数
                  </div>
                  <div
                    :class="
                      info.max_join_count
                        ? 'rules_top_item_text'
                        : 'f30 rules_top_item_text'
                    "
                  >
                    <template v-if="info.max_join_count"
                      >{{
                        info.max_join_count +
                          info.user_share_count -
                          info.joined_count >=
                        0
                          ? info.max_join_count +
                            info.user_share_count -
                            info.joined_count
                          : 0
                      }}<span class="sec-desc"
                        >/{{ info.max_join_count }}</span
                      ></template
                    >
                    <span v-else>无限制</span>
                  </div>
                </div>
              </div>
              <div class="rules-content">
                <div class="rules-content-item" v-if="info.enable_time_range">
                  时间：
                  <time :datetime="toDateTimeAttr(info.startDate)">{{ info.startDate }}</time>
                  至
                  <time :datetime="toDateTimeAttr(info.endDate)">{{ info.endDate }}</time>
                </div>
                <div
                  class="rules-content-item"
                  v-if="info.single_time_limit && info.single_time_limit > -1"
                >
                  每题限时：{{ info.single_time_limit }}秒，超时后无法作答
                </div>
              </div>
            </section>
            <footer class="owner" aria-label="发布者信息">
              <div class="r" v-if="isInApp">
                <img
                  :src="info.owner_avatar || info.avatar"
                  class="owner_avatar"
                  alt=""
                />
                <div class="name">{{ info.owner_name }}</div>
              </div>
              <div class="r position-r" v-else>
                <div class="flexCenter" @click="toHomePage(info.owner_unionid)">
                  <span class="owner_avatar-box position-r">
                    <img
                      :src="info.owner_avatar || info.avatar"
                      class="owner_avatar"
                      alt=""
                    />
                    <WxLink
                      v-if="isWeixin && isMobile"
                      :wxPath="ownerWxPath + info.owner_unionid"
                    />
                  </span>
                  <div>
                    <div class="name position-r">
                      {{ info.owner_name }}
                      <WxLink
                        v-if="isWeixin && isMobile"
                        :wxPath="ownerWxPath + info.owner_unionid"
                      />
                    </div>
                    <div v-if="!isInApp" @click.stop="handleVipBgClick()">
                      <div
                        class="level-tag position-r"
                        :class="{ active: info.enterprise_vip }"
                        v-if="info.enterprise_vip"
                      >
                        <img
                          class="level-icon"
                          :src="levelIcon[0].left"
                          alt="Level Icon"
                        />
                        {{ levelIcon[0].text }}
                        <img
                          v-if="info.is_owner"
                          class="level-icon-right"
                          :src="levelIcon[0].right"
                          alt="Level Icon Right"
                        />
                        <WxLink
                          v-if="
                            isWeixin &&
                              isMobile &&
                              !info.is_owner &&
                              !info.is_vip &&
                              !info.is_admin
                          "
                          :wxPath="ownerWxPath + info.owner_unionid"
                        />
                      </div>
                      <div
                        v-if="
                          !info.enterprise_vip &&
                            (info.is_owner || info.is_vip || info.is_admin)
                        "
                        class="vip-bg"
                      >
                        <img
                          class="vip-bg-img"
                          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-10-10/712d72026735810619e545241c95a284.svg"
                          alt="VIP Background"
                        />
                        <label>人数无限、防作弊等权限<span> ></span></label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <WxLink
                  v-if="isWeixin && isMobile"
                  :wxPath="ownerWxPath + info.owner_unionid"
                /> -->
              </div>
              <div class="btn-homepage position-r" v-if="!isInApp">
                <div class="flexCenter leave-wrap" @click="toMessage">
                  留言<span
                    v-if="
                      info.msg_total > 0 &&
                        (info.is_owner || info.is_vip || info.is_admin)
                    "
                    >{{ info.msg_total > 99 ? "99+" : info.msg_total }}</span
                  >
                  <img
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
                  />
                </div>
                <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
              </div>
            </footer>
          </section>
        </article>

        <template v-if="info.enterprise_vip || isInApp">
          <Contact
            :contact_info="info.contact_info"
            :contact_value="info.contact_value"
            :contact="info.contact"
          />
        </template>
        <div class="position-r" @click="rulesClick()">
          <WorkContent
            :rules="info.rules"
            :qid="info.qid"
            :isWeixin="isWeixin"
            :isMobile="isMobile"
            @handleRules="handleRules"
          />
          <WxLink
            v-if="isWeixin && isMobile && !info.enterprise_vip"
            :wxPath="wxPath + qid"
          />
        </div>
        <div
          class="position-r"
          v-if="info.award_type == 1 && info.awards && info.awards.length"
          @click="loadClick()"
        >
          <Awards
            :info="info"
            @handleVipTip="handleVipTip"
            :isMobile="isMobile"
            :isWeixin="isWeixin"
            @getLoginCode="getLoginCode"
          />
          <WxLink
            v-if="isWeixin && isMobile && !info.enterprise_vip"
            :wxPath="wxPath + qid"
          />
        </div>
        <!-- ad -->
        <div
          v-if="!isInApp && !info.enterprise_vip"
          class="add-box"
          :class="{
            'ad-mt': !(
              info.rules.length ||
              (info.award_type == 1 && info.awards && info.awards.length)
            ),
            'ad-pt':
              !info.rules.length &&
              !(info.award_type == 1 && info.awards && info.awards.length)
          }"
        >
          <Ad :isWeixin="isWeixin" :isMobile="isMobile" />
        </div>
        <div
          class="join-number cover"
          v-if="record_lists && record_lists.length && info.joined"
        >
          <div class="join-name flexCenterBetween position-r">
            <div>{{ info.temp == 3 ? "我的填写" : "我的成绩" }}</div>
            <div
              class="blue-arror pointer"
              @click.stop="toMessage"
              v-if="!isInApp"
            >
              所有
              <img
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
                class="blue-arror-img"
              />
              <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
            </div>
          </div>
          <div class="position-r">
            <RecordLists
              @handleVipTip="handleVipTip"
              :temp="info.temp"
              :records="record_lists"
              :hide_score="info.hide_score"
              :vip="info.enterprise_vip"
              :isMobile="isMobile"
              :isWeixin="isWeixin"
              :show_answer="info.show_answer"
            />
            <WxLink
              v-if="isWeixin && isMobile && !info.enterprise_vip"
              :wxPath="wxPath + qid"
            />
          </div>
        </div>
        <div
          class="rank position-r"
          v-if="
            (info.temp != 3 &&
              info.show_rank &&
              !info.hide_score &&
              info.unionid &&
              info.joined) ||
              (info.temp != 3 &&
                info.unionid &&
                (info.is_vip || info.is_admin || info.is_owner) &&
                info.joined)
          "
        >
          <RankLists
            :rankLists="rankLists"
            :info="info"
            @handleVipTip="handleVipTip"
            @getLoginCode="getLoginCode"
            :isMobile="isMobile"
            :isWeixin="isWeixin"
            :isInApp="isInApp"
            @toMessage="toMessage"
          />
          <WxLink
            v-if="isWeixin && isMobile && !info.enterprise_vip"
            :wxPath="wxPath + qid"
          />
        </div>
        <created-card
          :has_sub="info.has_sub"
          @createdClick="createdClick"
          v-if="
            info && !info.joined && (info.is_vip || info.is_owner) && !tempId
          "
        />
        <div class="statement-box" :class="{ active: tempId }"></div>

        <footer class="foot" v-if="info">
          <div class="foot-btn template-foot" v-if="tempId">
            <div
              class="position-r flex1 flex btn choose"
              :style="{ background: theme_color }"
            >
              <van-button
                class="temp-btn"
                type="primary"
                @click="isInApp ? copyTemplate() : toTemplateCenter()"
                >选用模板</van-button
              >
              <WxLink
                v-if="isWeixin && isMobile"
                :wxPath="wxPath + qid + '&tempId=' + tempId"
              />
            </div>
            <van-button
              class="invite-btn temp-btn flex1"
              type="primary"
              @click="tryTemplate"
              >体验答题</van-button
            >
          </div>
          <div class="foot-btn" v-else>
            <div class="handle-btns-left">
              <div class="home-wrap">
                <div
                  class="item-div position-r"
                  style="margin-right: 0;"
                  @click="toHome"
                >
                  <img :src="homeIcon" alt="" />
                  首页
                  <WxLink
                    v-if="isWeixin && isMobile && !info.enterprise_vip"
                    :path="wxPath + qid"
                  />
                </div>
              </div>
              <div @click="share" class="item-div">
                <img
                  src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230913/9120195b6557fb692358ebdf72394d20.png"
                  alt=""
                />
                分享
              </div>
              <div
                class="item-div"
                @click="showManage"
                v-if="info.is_owner || info.is_admin"
              >
                <img
                  src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/4ae475dd45a91e8a70345936aa05ca6b.png"
                  alt=""
                />
                管理
              </div>
            </div>
            <div class="handle-btns-right">
              <!-- add -->
              <button
                class="work-btn btn"
                :style="{ background: theme_color, opacity: '0.5' }"
                v-if="info.award_type == 1 && info.award_run_status == 2"
                @click="showTip"
              >
                已开奖
              </button>
              <button
                class="work-btn btn"
                :style="{ background: theme_color }"
                v-else-if="info.award_type == 1 && info.award_run_status == 3"
                @click="isEnd"
              >
                已结束
              </button>
              <button
                class="work-btn btn"
                :style="{ background: theme_color, opacity: '0.5' }"
                v-else-if="
                  info.award_type == 1 &&
                    info.award_run_status == 1 &&
                    info.factJoinStatus == 2 &&
                    info.award_run_way == 0
                "
                @click="showTip"
              >
                等待开奖
              </button>
              <button
                class="work-btn btn"
                :style="{ background: theme_color }"
                v-else-if="info.status != 1 && info.enable_time_range"
                @click="banStart(info.status == 0 ? 1 : 0)"
              >
                {{
                  info.status == 0 ? btn_text + "未开始" : btn_text + "已结束"
                }}
              </button>
              <div
                class="position-r w100 btn"
                v-else-if="info.factJoinStatus === 3"
              >
                <button
                  class="btn work-btn"
                  @click="toMessage"
                  :style="{ background: theme_color }"
                >
                  去分享增加次数
                </button>
                <WxLink v-if="isWeixin && isMobile" :path="wxPath + qid" />
              </div>
              <!-- add end -->
              <div class="position-r w100 btn" v-else>
                <button
                  class="btn work-btn"
                  @click="info.factJoinStatus == 2 ? showTip() : toDo()"
                  :style="{ background: theme_color }"
                >
                  {{
                    info.factJoinStatus == 2
                      ? "次数已用完"
                      : goOn
                      ? "继续"
                      : info.has_joined
                      ? "再次"
                      : "立即"
                  }}{{
                    info.factJoinStatus == 2
                      ? ""
                      : info.temp == 3
                      ? "参与"
                      : "答题"
                  }}
                </button>
                <WxLink
                  v-if="isWeixin && isMobile && !info.enterprise_vip"
                  :path="wxPath + qid"
                />
              </div>
            </div>
          </div>
        </footer>
      </template>
      <van-popup
        v-model="shareVisible"
        position="bottom"
        duration="0.1"
        :style="{ borderRadius: '4px 4px 0 0', background: 'transparent' }"
      >
        <manage-footer
          :info="info"
          :visible="shareVisible"
          @hideVisible="handleShareVisible"
        ></manage-footer>
      </van-popup>
      <van-popup
        v-model="showSetting"
        closeable
        close-icon="close"
        @closed="closedSetting"
        :style="{ borderRadius: '8px', width: '328px' }"
      >
        <Setting
          @changeSetting="changeSetting"
          :settingUrl="settingUrl"
          :settingSrc="settingSrc"
          :showType="showType"
          :qid="qid"
        />
      </van-popup>
      <van-popup
        v-model="showUpGrade"
        :style="{ borderRadius: '8px', width: '328px' }"
        closeable
        close-icon="close"
        @closed="closedSetting"
      >
        <div class="upgrage-wrapper">
          <div class="upgrage-title">
            <template v-if="UpGradeType">
              <template v-if="info.is_owner">
                该答题为基础版
                <br />
                仅高级版可以使用「H5版本作答」功能
                <br />
                以及其他高级版权限
              </template>
            </template>

            <template v-else
              >本场考试已开启防作弊限制，H5版本暂不支持，请扫码进入小程序答题</template
            >
          </div>
          <div
            class="contact-btn"
            v-if="info.is_owner && UpGradeType"
            @click="toVip()"
          >
            立即前往
          </div>
          <div
            class="contact-btn"
            v-if="info.is_owner && !UpGradeType"
            @click="handleContact(1)"
          >
            联系客服咨询
          </div>
          <div class="other-way" v-if="info.is_owner">
            <p><span></span><span></span><span></span></p>
            <div>其他参与方式</div>
            <p><span></span><span></span><span></span></p>
          </div>
          <div class="quesTitle lines-overflow">
            请前往「立吉答题」小程序参与
          </div>
          <img class="quesQrcode" :src="settingSrc" alt="" />
          <div class="upgrag-tip">微信长按或扫码参与答题</div>
        </div>
      </van-popup>
      <van-popup
        v-model="showAdTip"
        :style="{ borderRadius: '8px', width: '328px' }"
        closeable
        close-icon="close"
        @closed="showAdTip = false"
      >
        <div class="upgrage-wrapper">
          <div class="quesTitle lines-overflow">
            请前往「立吉答题」小程序参与
          </div>
          <img class="quesQrcode" :src="settingSrc" alt="" />
          <div class="upgrag-tip">微信长按或扫码参与答题</div>
        </div>
      </van-popup>

      <van-popup
        v-model="showVersionTipTemp"
        :style="{ borderRadius: '8px', width: '328px' }"
        closeable
        close-icon="close"
        @closed="showVersionTipTemp = false"
      >
        <div class="upgrage-wrapper">
          <div class="upgrage-title">
            H5版本暂不支持<br />
            请使用手机扫码，到小程序操作
          </div>
          <div class="other-way">
            <p><span></span><span></span><span></span></p>
            <div>其他参与方式</div>
            <p><span></span><span></span><span></span></p>
          </div>
          <div class="quesTitle lines-overflow">{{ info.title }}</div>
          <img
            class="quesQrcode"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-09-01/d977e33bbdc78985bfa9cad043690a50.png"
            alt=""
          />
          <div class="upgrag-tip">微信长按或扫码参与答题</div>
        </div>
      </van-popup>

      <van-popup
        v-model="showShare"
        :style="{ borderRadius: '8px', width: '330px' }"
        closeable
        close-icon="close"
        @closed="closeShare"
      >
        <div class="h5Link">
          <div class="h5Link-title">答题H5链接</div>
          <div class="h5Link-text" @click="copy">{{ url }}{{ info.qid }}</div>
          <div class="h5Link-tip" v-for="item in h5LinkTips" :key="item">
            <span class="h5Link-tip-text"></span>{{ item }}
          </div>
          <div class="h5Link-tipActive-box" v-if="!info.enterprise_vip">
            <div
              class="h5Link-tipActive"
              v-for="(item, index) in h5LinkTipsActive"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div
            class="h5Link-btn"
            v-clipboard:copy="url + info.qid"
            v-clipboard:success="copySuccess"
            @click="copy"
          >
            一键复制H5链接
          </div>
        </div>
      </van-popup>

      <van-popup
        v-model="showShareImg"
        :style="{ width: '300px', background: 'transparent' }"
      >
        <div class="shareimg-box">
          <img :src="prurl" alt="" />
          <div v-if="prurl">长按图片保存</div>
        </div>
      </van-popup>

      <ContactImg
        :visible="showContact"
        :src="
          serviceType
            ? 'https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-04-19/3df50a24e56b0ac8024d8ab92bedef34.png'
            : 'https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-04-19/3df50a24e56b0ac8024d8ab92bedef34.png'
        "
        @hideVisible="handleContact()"
      />
      <template v-if="showLogin">
        <ScanLogin @hideVisible="handleScan()" :src="loginQrcode"> </ScanLogin>
      </template>

      <template v-if="!isMobile && !isInApp && info.unionid && settingSrc">
        <right-code desc="微信扫一扫，打开小程序参与" :src="settingSrc">
          <div class="rightCode-btn">
            <button class="toCreate" @click="toPcCreate">我也要创建答题</button>
          </div>
        </right-code>
      </template>
      <van-popup
        v-model="showPreModal"
        position="bottom"
        duration="0.1"
        :style="{ borderRadius: '4px 4px 0 0', background: 'transparent' }"
      >
        <div class="eject-dialog-content">
          <div class="eject-dialog-body">
            <div class="header-title">
              {{ info.temp == 3 ? "填写" : "答题" }}规则
            </div>
            <div v-if="info.pw_switch && info.pw_check" class="pw-box">
              <div class="pw-title">口令</div>
              <div v-if="info.pw_remark" class="pw-remark">
                {{ info.pw_remark }}
              </div>
              <div class="password">
                <input
                  class="pass-input"
                  type="text"
                  maxlength="10"
                  v-model="pw"
                  placeholder="请先输入口令"
                />
                <img
                  @click="clearPw"
                  v-if="pw"
                  class="clear"
                  src="https://cdn.huomaqun.com/material/2024-01-25/787986a00e2977d9bbbe829b11c47b0e.png"
                  alt=""
                />
              </div>
              <div class="errTip" v-if="errTip">{{ errTip }}</div>
            </div>
            <div class="ques-rules">
              <div class="rules-box">
                <div class="rules-top">
                  <div class="rules_top_item">
                    <div class="rules_top_item_title">题数</div>
                    <div class="rules_top_item_text">
                      {{ info.ques_number }}
                    </div>
                  </div>
                  <div class="rules_top_item" v-if="info.temp !== 3">
                    <div class="rules_top_item_title">总分</div>
                    <div class="rules_top_item_text">{{ info.full_score }}</div>
                  </div>
                  <div class="rules_top_item">
                    <div class="rules_top_item_title">限时</div>
                    <div
                      class="rules_top_item_text"
                      :class="{ f30: !info.time_limit }"
                    >
                      <template v-if="info.time_limit">
                        {{ info.time_limit }}<span class="sec-desc">分钟</span>
                      </template>
                      <label v-else>无限制</label>
                    </div>
                  </div>
                  <div class="rules_top_item">
                    <div class="rules_top_item_title">
                      剩余次数
                    </div>
                    <div
                      class="rules_top_item_text"
                      :class="{ f30: !info.max_join_count }"
                    >
                      <template v-if="info.max_join_count">
                        {{
                          Math.max(
                            info.max_join_count +
                              info.user_share_count -
                              info.joined_count,
                            0
                          )
                        }}<span class="sec-desc"
                          >/{{ info.max_join_count }}</span
                        >
                      </template>
                      <span v-else>无限制</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="other-rules"
                v-if="info.single_time_limit > -1 || info.anti_cheating"
              >
                <div
                  class="o-rules-item"
                  v-if="info.single_time_limit && info.single_time_limit > -1"
                >
                  <img
                    class="rules-icon"
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-12-14/7a591ecd65c07798dea0a4885bfeb59f.png"
                  />
                  <div>
                    <div>单题限时：</div>
                    <div>
                      每题{{
                        info.single_time_limit
                      }}秒作答，超时后该题无法修改/作答
                    </div>
                  </div>
                </div>
                <div class="o-rules-item" v-if="info.anti_cheating">
                  <img
                    class="rules-icon"
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-12-14/43436d182632b75a15a7b65c5b0fbfa1.png"
                  />
                  <div>
                    <div>防作弊：</div>
                    <div>{{ anti_cheating_msg }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isInApp && !info.has_sub">
              <SubBox :has_sub="info.has_sub" :type="0" />
            </div>
            <div class="flexCenter confirm-btn">
              <button class="cancel-button" @click="closeEjectDialog">
                取消
              </button>
              <button
                class="confirm-button"
                :style="{ background: theme_color }"
                @click="todoContinue()"
              >
                {{ info.temp == 3 ? "开始填写" : "开始答题" }}
              </button>
            </div>
          </div>
        </div>
      </van-popup>
    </main>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '328px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <div class="upgrage-wrapper">
        <div class="upgrage-title">
          H5版本暂不支持<br />
          请使用手机扫码，到小程序操作
        </div>
        <div class="other-way">
          <p><span></span><span></span><span></span></p>
          <div>其他参与方式</div>
          <p><span></span><span></span><span></span></p>
        </div>
        <div class="quesTitle lines-overflow">{{ info ? info.title : "" }}</div>
        <img class="quesQrcode" :src="settingSrc" alt="" />
        <div class="upgrag-tip">微信长按或扫码参与答题</div>
      </div>
    </van-popup>
    <van-popup
      v-model="showOwnerVersionTip"
      :style="{ borderRadius: '8px', width: '328px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <div class="upgrage-wrapper">
        <div class="upgrage-title">
          H5版本暂不支持<br />
          请使用手机扫码，到小程序操作
        </div>
        <div class="other-way">
          <p><span></span><span></span><span></span></p>
          <div>其他参与方式</div>
          <p><span></span><span></span><span></span></p>
        </div>
        <div class="quesTitle lines-overflow">{{ info ? info.title : "" }}</div>
        <img class="quesQrcode" :src="ownerSrc" alt="" />
        <div class="upgrag-tip">微信长按或扫码参与答题</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import { Toast, Dialog, ImagePreview } from "vant";
import RankLists from "@/components/detail/rankList";
import RecordLists from "@/components/detail/recordList";
import HomeIcon from "@/components/homeIcon";
import Setting from "@/components/detail/setting";
import Awards from "@/components/detail/awards";
import ContactImg from "@/components/contactImg";
import WorkContent from "@/components/detail/workcontent";
import Contact from "@/components/detail/contact";
import ScanLogin from "@/components/scanLogin";
import RightCode from "../../components/rightCode.vue";
import SubBox from "@/components/subBox";
import WxLink from "@/components/wxLink.vue";
import { levelIcon } from "@/utils/config";
import Ad from "../../components/common/ad.vue";
import DetailFail from "../../components/detail/detailFail.vue";
import ManageFooter from "../../components/manageFooter.vue";
import CreatedCard from "../../components/detail/createdcard.vue";

import { throttle } from "lodash";
let checkTime = 0;
let intervalAsk;

import {
  getToken,
  formatDate,
  formatMinuteNew,
  setShareInfo,
  reLogin,
  getDetailWxCode,
  isMobile,
  getWxUrl,
  getCacheStatus,
  changeCacheStatus,
  getQueryString,
  handleCode,
  getBindToken,
  checkNetWork,
  getLocalTime,
  isWeixin,
  isLikelyCrawlerEnv,
  showServiceAble,
  jumpVip,
  vipClick,
  randomString,
  handleZI
} from "@/utils/common";
import api from "@/utils/api";
import {
  buildDetailLoadingSeo,
  buildDetailMissingSeo,
  buildDetailSeo,
  setSeo
} from "@/utils/seo";

export default {
  data() {
    return {
      showFooter: false,
      dataNotFound: 0,
      lostData: {},
      verifyingIcon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/445a8a9c2ce41c9c66c3939ae5351df5.svg",
      violationIcon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/aaad6764c86d15b1d4b4074927b38d10.jpg",
      levelIcon: levelIcon,
      prurl: "",
      showShareImg: false,
      showAdTip: false,
      h5LinkTips: ["参与环境更聚焦-只展示本答题相关内容"],
      h5LinkTipsActive: [
        "该功能是高级版功能：",
        "基础版-进入H5页面仅展示活动详情，无法参与答题"
      ],
      url: `https://m.xiaoxiaodati.com/${
        api.baseUrl.indexOf("pre.") > 0 ? "test/" : ""
      }normal/detail?qid=`,
      wxPath: "/pages/detail/detail?qid=",
      ownerWxPath: "/pages/homepage/homepage?unionid=",
      info: null,
      qid: "",
      tempId: "",
      rankLists: [],
      isInApp: wemeet.app.isTMWebview(),
      isWeixin: isWeixin(),
      showSetting: false,
      isMobile: isMobile(),
      settingUrl: "",
      settingUrlTemp: "",
      settingSrc: "",
      ownerSrc: "",
      ownerPath: "",
      showOwnerVersionTip: false,
      showType: 0,
      homeIcon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/347c739b5b82ea477bc31894460f94a2.png",
      goOn: 0,
      record_lists: [],
      staging_switch: 0,
      staging_data: {},
      showContact: false,
      showUpGrade: false,
      serviceType: 0,
      auth_code: "test",
      token: "",
      UpGradeType: 1,
      countIcon: [
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220825/2022-08-25/7e85f708ef4b1df0b24298a50fd585e5.svg",
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220825/2022-08-25/794160c54e1c61f000a8470671acc1ea.svg"
      ],
      pre_way: 0,
      showLogin: false,
      showScan: false,
      loginQrcode: "",
      showShare: false,
      showVersionTip: false,
      showVersionTipTemp: false,
      status_text: "",
      theme_color: "#1890FF",
      shareVisible: false,
      showPreModal: false,
      ruleType: 0,
      anti_cheating_msg: "",
      continueType: "",
      errTip: "",
      pw: "",
      btn_text: "答题"
    };
  },
  filters: {
    accMul: function(arg1) {
      var arg2 = 100;
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      if (s1.split(".")[1]) {
        m += s1.split(".")[1].length;
      }
      if (s2.split(".")[1]) {
        m += s2.split(".")[1].length;
      }
      return (
        (s1.replace(".", "") * 1 * (s2.replace(".", "") * 1)) / Math.pow(10, m)
      );
    }
  },
  components: {
    RankLists,
    HomeIcon,
    RecordLists,
    Setting,
    Awards,
    ContactImg,
    WorkContent,
    Contact,
    ScanLogin,
    RightCode,
    SubBox,
    WxLink,
    ManageFooter,
    Ad,
    DetailFail,
    CreatedCard
  },
  async mounted() {
    setSeo(buildDetailLoadingSeo(this.$route.query.qid || this.qid));
    if (!this.isInApp && !getToken() && getQueryString("code")) {
      let res = await handleCode(getQueryString("code"));
      if (res) {
        let arr = document.location.toString().split("&code=")[0];
        window.location.replace(arr);
      }
      return;
    }
    if (localStorage.getItem("qid")) localStorage.removeItem("qid");
    if (localStorage.getItem("template_id"))
      localStorage.removeItem("template_id");

    if (this.$route.query.qid) {
      this.qid = this.$route.query.qid;
      this.tempId = this.$route.query.tempId;
      setSeo(buildDetailLoadingSeo(this.qid));
      if (this.isInApp && getQueryString("auth_code")) {
        let res = await getBindToken(getQueryString("auth_code"));
        if (res) {
          let preToken = localStorage.getItem("token");
          localStorage.setItem("token", res.access_token);
          localStorage.setItem("bind_status", res.bind_status || 0);
          this.$router.replace({
            name: "normalDetail",
            query: { qid: this.qid }
          });
          this.token = getToken();
          this.getInfo(preToken ? "" : "toDo");
        }
        return;
      }
      this.getInfo();
    } else {
      let fullPath = this.$route.fullPath;
      let index = fullPath.lastIndexOf("qid=");
      if (index >= 0) {
        fullPath = fullPath.substring(index + 4, fullPath.length);
        this.qid = fullPath.split("&")[0];
        setSeo(buildDetailLoadingSeo(this.qid));
        this.getInfo();
      }
    }
    this.bind_status = localStorage.getItem("bind_status");
    this.token = getToken();
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
  },
  destroyed() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
  },
  methods: {
    toDateTimeAttr(value) {
      return value ? value.replace(" ", "T") : "";
    },
    transNumWan(num) {
      if (typeof num !== "number") {
        num = parseFloat(num);
      }
      if (isNaN(num)) {
        return "0";
      }
      if (num < 10000) {
        return num;
      }
      // 直接截断到小数点后一位，不进行四舍五入
      var divided = num / 10000;
      var integerPart = Math.floor(divided);
      var decimalPart = Math.floor((divided - integerPart) * 10);
      if (decimalPart === 0) {
        return integerPart + "万";
      }
      return integerPart + "." + decimalPart + "万";
    },
    rulesClick() {
      if (!this.isInApp && !this.info.unionid) {
        if (this.isWeixin) {
          return this.handleErr("/normal/detail?qid=" + this.qid);
        } else {
          // 非微信或者腾讯会议环境
          this.getLoginCode(this.isMobile ? true : "");
          return;
        }
      }
      if (!this.isInApp && !this.info.enterprise_vip) {
        this.toMessage();
      }
    },
    loadClick() {
      if (!this.isInApp && !this.info.unionid) {
        if (this.isWeixin) {
          return this.handleErr("/normal/detail?qid=" + this.qid);
        } else {
          // 非微信或者腾讯会议环境
          this.getLoginCode(this.isMobile ? true : "");
          return;
        }
      }
    },
    banStart(type) {
      if (this.loginJudge()) {
        this.pause(type);
      }
    },
    isEnd() {
      if (this.loginJudge()) {
        Dialog.confirm({
          message:
            "该答题活动已开奖，前往发起人主页点击订阅，等待下次活动开启吧！",
          confirmButtonText: "去订阅",
          confirmButtonColor: "#1890ff"
        }).then(() => {
          this.toHomePage(this.info.owner_unionid);
        });
      }
    },
    handleAudit() {
      questionOnly
        .get(api.question.getList, {
          access_token: getToken(),
          page: 1,
          count: 10,
          type: 0
        })
        .then(() => {});
    },
    getAuditStatus() {},
    createdClick(index) {
      if (index == 2) {
        this.showManage();
      } else if (index == 0) {
        let url = "https://mp.weixin.qq.com/s/j9hHKHMYCZDZmulLZzql5w";
        if (this.isMobile) {
          window.location.href = url;
        } else {
          window.open(url);
        }
      } else if (index == 1) {
        this.share();
      }
    },
    previewImage(data) {
      ImagePreview({
        images: [data],
        startPosition: 0
      });
    },
    handleRules(item) {
      if (this.isInApp) {
        // 腾讯会议里面直接弹框
        this.showVersionTip = true;
      } else {
        if (item.status) {
          // 不允许下载
          this.toMessage();
        } else {
          window.open(item.value);
        }
      }
    },
    auditClick() {
      vipClick("audit");
      if (!this.isInApp) {
        localStorage.setItem(
          "toPay",
          JSON.stringify({
            qid: this.qid,
            token: getToken()
          })
        );
        jumpVip(this);
      } else {
        this.showManage();
      }
    },
    toIndexPage() {
      this.$router.push({ name: "home" });
    },
    clearPw() {
      this.pw = "";
    },
    tagTip(type) {
      if (type == 1) {
        Dialog.confirm({
          message:
            "本场考试已开启防作弊功能，请勿离开答题页面，或做切屏/截屏/分屏/录屏等操作，异常操作后会触发自动提交",
          showCancelButton: false,
          confirmButtonText: "我知道啦",
          confirmButtonColor: "#1890ff"
        });
      } else if (type == 0) {
        // 答题人数
        let { joined, joined_limit, is_owner } = this.info || {};
        if (!joined) joined = 0;
        if (is_owner && joined_limit != -1) {
          Dialog.confirm({
            message: `当前答题已有${joined}人参与，上限${
              joined_limit == -1 ? "无限制" : joined_limit + "人"
            }如需增加上限，点击下方进入设置修改`,
            confirmButtonText: "去设置",
            confirmButtonColor: "#1890ff"
          }).then(() => {
            this.showManage();
          });
        } else {
          Dialog.confirm({
            message: `当前答题已有${joined}人参与，上限${
              joined_limit == -1 ? "无限制" : joined_limit + "人"
            }`,
            showCancelButton: false,
            confirmButtonText: "我知道啦",
            confirmButtonColor: "#1890ff"
          });
        }
      } else if (type == 2) {
        // 答题次数
        let { is_owner, total_join_limit, total_join } = this.info || {};
        if (!total_join) total_join = 0;
        if (is_owner && total_join_limit != -1) {
          Dialog.confirm({
            message: `当前答题已有${total_join}次参与，上限${
              total_join_limit == -1 ? "无限制" : total_join_limit + "次"
            }如需增加上限，点击下方进入设置修改`,
            confirmButtonText: "去设置",
            confirmButtonColor: "#1890ff"
          }).then(() => {
            this.showManage();
          });
        } else {
          Dialog.confirm({
            message: `当前答题已有${total_join}次参与，上限${
              total_join_limit == -1 ? "无限制" : total_join_limit + "次"
            }`,
            showCancelButton: false,
            confirmButtonText: "我知道啦",
            confirmButtonColor: "#1890ff"
          });
        }
      }
    },
    todoContinue() {
      this.toDoSecond(this.continueType);
    },
    closeEjectDialog() {
      this.showPreModal = false;
    },
    handleVipBgClick() {
      if (!this.info.unionid) {
        // 没登录先登录去
        if (this.isWeixin) {
          return this.handleErr("/normal/detail?qid=" + this.qid);
        } else {
          // 非微信或者腾讯会议环境
          this.getLoginCode(this.isMobile ? true : "");
          return;
        }
      } else {
        if (this.info.is_owner || this.info.is_vip) {
          // 出题人 | 上帝模式
          jumpVip(this);
        } else {
          this.toHomePage(this.info.owner_unionid);
        }
      }
    },
    handleShareVisible() {
      this.shareVisible = false;
    },
    async toHomePage(unionid) {
      if (!this.info.unionid) {
        // 没登录先登录去
        if (this.isWeixin) {
          return this.handleErr("/normal/detail?qid=" + this.qid);
        } else {
          // 非微信或者腾讯会议环境
          this.getLoginCode(this.isMobile ? true : "");
          return;
        }
      }
      if (this.isMobile) {
        if (!this.ownerUrl) {
          let res = await getWxUrl("pages/homepage/homepage", unionid, 1);
          if (res) {
            this.ownerUrl = res;
          }
        }
        window.location.href = this.ownerUrl;
        return;
      } else {
        if (!this.ownerSrc) {
          this.ownerSrc = await getDetailWxCode(unionid, 15);
        }
        this.showOwnerVersionTip = true;
      }
    },
    reset() {
      localStorage.setItem("token", "212");
      Toast("重置成功");
    },
    cleartoken() {
      localStorage.clear();
      sessionStorage.clear();
      Toast("token已清除");
    },
    handleLaunchFn() {},
    handleErrorFn() {},
    async toTemplateCenter() {
      if (this.isMobile) {
        if (!this.settingUrlTemp) {
          let res = await getWxUrl(
            "subPages/pages/templateCenter/templateCenter",
            "",
            1
          );
          if (res) {
            this.settingUrlTemp = res;
            window.location.href = this.settingUrlTemp;
          }
        } else {
          window.location.href = this.settingUrlTemp;
        }
      } else {
        this.showVersionTipTemp = true;
      }
    },
    async toMessage() {
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.qid, 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        if (!this.settingSrc) {
          this.settingSrc = await getDetailWxCode(this.qid);
        }
        this.showVersionTip = true;
      }
    },
    copySuccess() {
      Toast("复制成功");
    },
    closeShare() {},
    hideTipModal() {},
    copy() {},

    async getLoginCode(mobile) {
      if (mobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.qid, 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      }
      var timestamp = new Date().getTime();
      var myToken =
        timestamp + Math.ceil(Math.random() * 1000000000000000) + "";
      // 获取二维码  开始轮询请求，如果返回ok，清除轮询
      questionOnly
        .get("/xcx/ques_web/v1/qrcode", { token: myToken })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 0;
            if (!this.showLogin) this.showLogin = true;
            checkTime = 0;
            this.checkLoginSuccess(myToken);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    checkLoginSuccess(myToken) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getLoginCode();
        return;
      }
      questionOnly
        .get("/xcx/ques_web/v1/check_status", {
          token: myToken,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(myToken);
            }, 3000);
          } else {
            // 登录成功
            localStorage.setItem("token", res.data.access_token);
            handleZI(res.data.mp_openid);
            setTimeout(async () => {
              this.showLogin = false;
              this.getInfo();
              if (!this.settingSrc)
                this.settingSrc = await getDetailWxCode(this.qid);
            }, 100);
          }
        });
    },
    handleScan() {
      if (intervalAsk) {
        clearInterval(intervalAsk);
        intervalAsk = null;
      }
      this.showLogin = !this.showLogin;
    },
    async handleVipTip(UpGradeType = 1) {
      if (!this.settingSrc) {
        let res = await getDetailWxCode(this.qid);
        if (res) {
          this.settingSrc = res;
          this.UpGradeType = UpGradeType;
          this.showUpGrade = true;
        }
      } else {
        this.UpGradeType = UpGradeType;
        this.showUpGrade = true;
      }
    },
    async judgeVip() {
      if (!this.isInApp && !this.info.enterprise_vip) {
        if (this.isMobile) {
          if (!this.settingUrl) {
            let res = await getWxUrl("pages/detail/detail", this.qid, 1);
            if (res) {
              this.settingUrl = res;
            }
          }
          window.location.href = this.settingUrl;
          return;
        } else {
          this.handleVipTip();
        }
      }
    },
    async handleContact(type = 0) {
      let res = await showServiceAble();
      if (res) {
        this.serviceType = type;
        this.showContact = !this.showContact;
      }
    },
    closedSetting() {
      this.showSetting = false;
      setTimeout(() => {
        this.getInfo();
      }, 500);
    },
    // 管理答题
    async showManage() {
      if (this.isMobile) {
        this.showType = 0;
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.qid);
          if (res) {
            this.settingUrl = res;
            this.showSetting = true;
          }
        } else {
          this.showSetting = true;
        }
      } else {
        this.showType = 1;
        if (this.settingSrc) {
          this.showSetting = true;
        } else {
          let res = await getDetailWxCode(this.qid);
          if (res) {
            this.settingSrc = res;
            this.showSetting = true;
          }
        }
      }
    },
    changeSetting(val) {
      let { type, value } = val;
      this[type] = value;
    },
    // 体验答题
    tryTemplate() {
      if (!this.loginJudge()) {
        return;
      }
      localStorage.setItem(
        "start_time_" + this.qid,
        parseInt(getLocalTime() / 1000)
      );
      this.$router.push({ name: "doNormal", query: { qid: this.qid, try: 1 } });
    },
    toVip() {
      this.showUpGrade = false;
      window.location.href = "https://cert.xiaoxiaodati.com/vip";
    },
    async toHome() {
      if (this.isInApp || (this.info.enterprise_vip && this.info.unionid)) {
        this.$router.push({ name: "home" });
      } else {
        if (!this.isWeixin && !this.isMobile && !this.info.unionid) {
          this.getLoginCode();
          return;
        }
        if (!this.isWeixin && this.isMobile && !this.info.unionid) {
          this.getLoginCode(true);
          return;
        }
        if (!this.info.enterprise_vip) {
          if (this.isMobile) {
            if (!this.settingUrl) {
              let res = await getWxUrl("pages/detail/detail", this.qid, 1);
              if (res) {
                this.settingUrl = res;
              }
            }
            window.location.href = this.settingUrl;
            return;
          } else {
            this.handleVipTip();
          }
          return;
        }
        this.$router.push({ name: "home" });
      }
    },
    showTip() {
      if (this.loginJudge()) {
        let info = this.info || {};
        if (info.award_type == 1 && info.award_run_status == 2) {
          Dialog.confirm({
            message:
              "该答题活动已开奖，前往发起人主页点击订阅，等待下次活动开启吧！",
            confirmButtonText: "去订阅",
            confirmButtonColor: "#1890ff"
          }).then(() => {
            this.toHomePage(this.info.owner_unionid);
          });
          return;
        }
        if (
          info.award_type == 1 &&
          info.award_run_status == 1 &&
          info.join_status == 2
        ) {
          if (info.award_run_way == 0) {
            let date_str = info.award_run_time;
            date_str = formatDate(date_str * 1000, "yyyy年MM月dd日 HH:mm");
            Dialog({
              message:
                "已完成答题，将在" +
                date_str +
                " 时自动开奖。\n将通过立吉答题公众号发送开奖结果提醒。",
              confirmButtonText: "等待开奖",
              confirmButtonColor: "#1890FF"
            });
            return;
          }
        }
        this.pause(3);
      }
    },
    share() {
      if (this.info.is_owner && this.isInApp) {
        window.wemeet.app.shareOpenApp();
      } else {
        // 先判断有没有登录
        if (!getToken()) {
          if (this.isInApp || this.isWeixin) {
            return this.handleErr("/normal/detail?qid=" + this.qid);
          } else {
            // 非微信或者腾讯会议环境
            this.getLoginCode(this.isMobile ? true : "");
            return;
          }
        } else {
          if (!this.info.allow_share && !this.info.is_owner) {
            Toast("出题人设置了不允许分享");
          } else {
            if (this.isInApp) {
              this.showShare = true;
            } else {
              this.shareVisible = true;
            }
          }
        }
      }
    },
    loginJudge() {
      if (!getToken()) {
        if (this.isInApp || this.isWeixin) {
          this.handleErr("/normal/detail?qid=" + this.qid);
          return false;
        } else {
          // 非微信或者腾讯会议环境
          this.getLoginCode(this.isMobile ? true : "");
          return false;
        }
      }
      return true;
    },
    toDo: throttle(
      async function(type = "") {
        if (!this.isInApp && !this.info.enterprise_vip) {
          return this.judgeVip();
        }
        if (!getToken()) {
          if (this.isInApp || this.isWeixin) {
            return this.handleErr("/normal/detail?qid=" + this.qid);
          } else {
            // 非微信或者腾讯会议环境
            this.getLoginCode(this.isMobile ? true : "");
            return;
          }
        }
        let {
          ques_number,
          is_owner,
          screen_cut_count = -1,
          screen_shot_count = -1,
          temp,
          screen_record_ban,
          is_audit,
          enterprise_vip,
          ban_parsing_img = 0,
          ban_paste,
          pw_switch,
          pw_check,
          time_limit,
          max_join_count,
          award_type
        } = this.info;
        if (!enterprise_vip && !this.isInApp) {
          // h5非会员
          if (!this.settingSrc) {
            this.settingSrc = await getDetailWxCode(this.qid);
          }
          return (this.showUpGrade = true);
        }
        if (ques_number == 0) {
          Dialog({
            message: "该答题内无题目，无法正常答题，请联系出题人完善出题"
          });
          return;
        }
        if (is_audit != 0 && is_audit != null) {
          Dialog({ message: "审核中的答题和违规的答题不允许参与" });
          return;
        }
        // 有奖答题没有奖品不允许答题
        if (
          award_type == 1 &&
          (!this.info.awards || !this.info.awards.length)
        ) {
          let msg = is_owner ? "" : "联系出题人";
          Dialog.confirm({
            message: `当前答题没有奖品，请${msg}前往小程序[修改设置里]添加奖品`,
            confirmButtonColor: "#1890ff	"
          }).then(async () => {
            if (!this.settingSrc) {
              this.settingSrc = await getDetailWxCode(this.qid);
            }
            return (this.showUpGrade = true);
          });
          return;
        }
        if (
          (screen_cut_count > -1 ||
            screen_shot_count > -1 ||
            screen_record_ban ||
            ban_parsing_img ||
            ban_paste) &&
          (temp != 3 || temp != 5)
        ) {
          //防作弊限制
          this.handleVipTip(0);
          return;
        }
        if (this.goOn) {
          // 继续答题
          checkNetWork().then(() => {
            // 老的方法
            if (this.pre_way) {
              this.$router.push({ name: "doNormal", query: { qid: this.qid } });
            } else {
              let { staging_switch, qid, info } = this;
              if (staging_switch) {
                getCacheStatus(qid, 1, info.staging_data.rec_staging_id).then(
                  (staging_data = {}) => {
                    let { status, alert, rec_staging_id } = staging_data;
                    let { enable_time_range = 0, t_end = 0 } = info;
                    if (status && !alert) {
                      changeCacheStatus(qid, rec_staging_id).then(() => {
                        this.judgeStagingInfo(staging_data);
                      });
                    } else {
                      if (status && alert) {
                        this.judgeStagingInfo(staging_data, 1);
                      } else {
                        // 答题时间段判断
                        if (
                          enable_time_range &&
                          getLocalTime() > t_end * 1000
                        ) {
                          Dialog({ message: "答题已到结束时间" });
                          getDetail(this);
                          return;
                        }
                        this.$router.push({
                          name: "doNormal",
                          query: { qid: this.qid }
                        });
                      }
                    }
                  }
                );
              } else {
                this.$router.push({
                  name: "doNormal",
                  query: { qid: this.qid }
                });
              }
            }
          });
          return;
        } else {
          // 开始答题
          if (localStorage.getItem(this.qid)) {
            localStorage.setItem("is_submit", 1);
            localStorage.removeItem(this.qid);
            localStorage.removeItem("start_time_" + this.qid);
            localStorage.removeItem("count_down_time_" + this.qid);
          }
          // 判断答题时间段截止时间
          if (
            this.info.enable_time_range &&
            getLocalTime() > this.info.t_end * 1000
          ) {
            Dialog({
              message: "答题已到结束时间"
            });
            this.getInfo();
            return;
          }
          let need_pw = pw_switch && pw_check ? true : false;
          if (max_join_count == 0 && time_limit == 0 && !need_pw) {
            return this.toDoSecond();
          }
          this.pw = "";
          this.errTip = "";
          this.showPreModal = true;
          this.continueType = type;
        }
      },
      2000,
      { trailing: false }
    ),
    toDoThird(content) {
      this.realToDo();
    },
    toDoSecond(content) {
      this.checkJoinStatus(content);
    },
    checkJoinStatus(content) {
      let { pw_switch, pw_check } = this.info;
      let command = this.pw;
      if (pw_switch && pw_check && command == "") {
        this.errTip = "口令错误";
        return;
      }
      let param = {
        access_token: getToken(),
        qid: this.qid,
        ...(pw_switch && pw_check ? { command } : {})
      };
      questionOnly.post("/xcx/ques/v2/assign/check", param).then(res => {
        if (res.sta == 0) {
          let { reg_required, has_reged } = res.data;
          if (reg_required == 1 && has_reged == 0) {
            this.$router.push({
              name: "enroll",
              query: {
                qid: this.qid,
                unionid: this.info.unionid,
                theme_color: this.theme_color
              }
            });
          } else {
            this.toDoThird(content);
          }
        } else if (res.sta === -500) {
          this.handleErr("/normal/detail?qid=" + this.qid);
        } else if (
          res.sta === -1 &&
          (res.errcode === 110 || res.errcode === 113 || res.errcode === 118)
        ) {
          this.pause(res.errcode === 118 ? 5 : 2);
        } else if (res.sta === -1 && res.errcode == 126) {
          this.errTip = "口令错误";
        } else {
          Toast(res.msg);
        }
      });
    },
    realToDo() {
      // 如果参与了，就不走check，没参与走check
      let param = {
        access_token: getToken(),
        qid: this.qid,
        xcx_version: "1.0.0",
        version_code: 1
      };

      questionOnly.post("/xcx/ques/v2/start", param).then(res => {
        if (res.sta == 0) {
          localStorage.setItem("start_time_" + this.qid, res.data.now);
          this.$router.push({ name: "doNormal", query: { qid: this.qid } });
        } else if (res.sta === -500) {
          this.handleErr("/normal/detail?qid=" + this.qid);
        } else if (
          res.sta == -1 &&
          (res.errcode == 110 ||
            res.errcode == 113 ||
            res.errcode == 115 ||
            res.errcode == 118)
        ) {
          let { errcode } = res;
          let { wait_status = 0 } = res.data || {}; // wait_status 0:排队人谁没超过50, 1: 排队人数超出50
          let pauseType = errcode == 115 ? 4 : errcode == 118 ? 5 : 2;
          this.pause(pauseType, wait_status);
        } else {
          Toast(res.msg);
        }
      });
    },
    pause(type, wait_status) {
      if (type == 2 && this.info.is_owner) {
        Dialog.confirm({
          title: "温馨提示",
          message: "答题人数已达到上限，如需参与答题，请修改【限制答题人数】",
          confirmButtonText: "前往修改",
          confirmButtonColor: "#1890ff",
          cancelButtonText: "我知道了",
          cancelButtonColor: "#262626"
        }).then(() => {
          this.$router.push({ name: "helpCenter", query: { qid: this.qid } });
        });
        return;
      }
      let query = { type, qid: this.qid, delta: 1 };
      if (wait_status) query.wait_status = 1;
      this.$router.push({ name: "detailPause", query: query });
    },
    getInfo(directTodo) {
      let param = {
        qid: this.qid,
        access_token: getToken(),
        xcx_version: "1.0.0",
        version_code: 1,
        ...(this.tempId ? { source: 1 } : {})
      };
      if (localStorage.getItem("toPay") || localStorage.getItem("openWechat")) {
        param.reload = randomString(6);
        localStorage.removeItem("openWechat");
      }
      if (this.tempId) param.template_id = this.qid;
      let url = "/xcx/ques/v1/detail/home";
      // let url = this.tempId
      //   ? "/xcx/ques/v1/template/detail"
      // : "/xcx/ques/v1/detail/home";
      questionOnly.get(url, param).then(async res => {
        if (res.sta == 0) {
          var info = res.data;
          // info.is_audit = 1;
          // info.is_violation = 0;
          // info.enterprise_vip = 0;
          // info.is_vip = 0;
          if (localStorage.getItem("toPay")) {
            localStorage.removeItem("toPay");
          }
          this.theme_color = info.theme_color || "#1890FF";
          info.startDate = info.t_start
            ? formatDate(
                new Date(info.t_start * 1000),
                "yyyy-MM-dd HH:mm",
                "sameYear"
              )
            : "";
          info.endDate = info.t_end
            ? formatDate(
                new Date(info.t_end * 1000),
                "yyyy-MM-dd HH:mm",
                "sameYear"
              )
            : "";
          info.awardRuntime = info.award_run_time
            ? formatDate(
                new Date(info.award_run_time * 1000),
                "yyyy-MM-dd HH:mm",
                "sameYear"
              )
            : "";
          setSeo(buildDetailSeo(this.qid, info));
          let {
            max_join_count,
            share_add_count,
            allow_share_add,
            joined_count,
            today_joined_count,
            allow_share,
            join_status,
            temp,
            max_join_type
          } = info;
          if (max_join_type) {
            joined_count = today_joined_count;
            info.joined_count = today_joined_count;
          }
          // 答题次数为无限制 || 不允许分享
          if (
            temp == 3 ||
            max_join_count == 0 ||
            allow_share == 0 ||
            join_status != 2
          ) {
            info.factJoinStatus = join_status;
          } else {
            // 已设置为可允许通过分享添加答题次数
            let factMaxJoinCount = max_join_count + share_add_count; // 实际可答题次数
            if (
              (allow_share_add && share_add_count == 0) ||
              (allow_share_add && joined_count < factMaxJoinCount)
            ) {
              if (allow_share_add && joined_count < factMaxJoinCount) {
                info.factJoinStatus = 1;
              } else {
                info.factJoinStatus = 3;
              }
            } else {
              info.factJoinStatus = 2;
            }
            if (max_join_count == joined_count) {
              info.factJoinStatus = allow_share_add ? 3 : 2;
            }
          }
          // factJoinStatus 1: 有次数 2: 次数已用完  3: 没有答题次数了但是可以分享得到次数
          // 判断是否开启了防作弊
          if (
            info.screen_cut_count > -1 ||
            info.screen_shot_count > -1 ||
            info.screen_record_ban
          ) {
            info.anti_cheating = true;
          }
          if (
            info.total_join_limit == null ||
            info.total_join_limit == undefined
          ) {
            info.total_join_limit_empty = true;
          }
          info.total_join = info.total_join || 0;
          // 中奖记录时间戳转换
          info.my_awards = info.my_awards || [];
          info.my_awards.map(item => {
            item.t_submit = formatDate(
              new Date(item.t_submit * 1000),
              "yyyy-MM-dd HH:mm",
              "sameYear"
            );
          });
          this.info = info;
          this.btn_text = info.temp == 3 ? "问卷" : "答题";
          let status_text = "进行中";
          if (!info.enable_time_range) {
            status_text = "进行中";
          } else {
            let now = new Date().getTime();
            if (info.t_start * 1000 > now) {
              status_text = "未开始";
            }
            if (info.t_end * 1000 < now) {
              status_text = "已结束";
            }
          }
          this.status_text = status_text;
          this.goOn = localStorage.getItem(this.qid) ? 1 : 0;
          setShareInfo(true, info.title);
          if (localStorage.getItem("detailShare")) {
            this.share();
            localStorage.removeItem("detailShare");
          }
          if (this.isInApp) {
            let { nickname = "" } =
              JSON.parse(localStorage.getItem("userInfo")) || {};
            localStorage.setItem(
              "info",
              JSON.stringify({ ...info, meet_name: nickname })
            );
            if (directTodo) this.toDo();
          } else {
            localStorage.setItem("info", JSON.stringify({ ...info }));
          }
          // 缓存处理
          this.handleStaging(res.data);
          if (info.unionid) {
            this.getDetailSecond();
          } else if (
            !info.unionid &&
            !this.isWeixin &&
            !this.isMobile &&
            !getToken() &&
            !isLikelyCrawlerEnv()
          ) {
            this.getLoginCode();
          }
          if (
            !this.isInApp &&
            (!this.isMobile || (this.isMobile && !info.enterprise_vip)) &&
            !this.settingSrc
          ) {
            this.settingSrc = await getDetailWxCode(this.qid);
          }
        } else if (res.sta === -500) {
          if (this.isInApp || this.isWeixin) {
            this.handleErr("/normal/detail?qid=" + this.qid);
          } else {
            localStorage.removeItem("token");
            this.getInfo();
          }
        } else {
          if (res && res.data && res.errcode == 101) {
            this.lostData = {
              name: res.data.owner_name || "",
              unionid: res.data.unionid || "",
              enterprise_vip: res.data.enterprise_vip || 0,
              // is_owner: 0,
              is_owner: res.data.is_owner || 0,
              deleted: 0
            };
          }
          if (res && res.errcode == 119) {
            // 彻底删除了的答题
            this.lostData = {
              deleted: 1
            };
          }
          this.dataNotFound = res && res.errcode == 123 ? 0 : 1;
          setSeo(buildDetailMissingSeo(this.qid, this.lostData));
        }
      });
    },
    copyTemplate() {
      let param = {
        qid: this.qid,
        access_token: getToken(),
        copy_type: 1,
        temp_id: this.tempId,
        version_code: 1,
        xcx_version: "1.0.0"
      };
      questionOnly.post("/xcx/ques/v1/copy_create", param).then(res => {
        if (res.sta == 0) {
          Toast("创建成功");
          this.tempId = "";
          this.$router.replace({
            name: "normalDetail",
            query: { qid: res.data.qid }
          });
          this.qid = this.$route.query.qid;
          this.tempId = this.$route.query.tempId;
          if (localStorage.getItem("template_id"))
            localStorage.removeItem("template_id");
          this.getInfo();
        } else if (res.sta === -500) {
          localStorage.setItem(
            "template_id",
            JSON.stringify({
              qid: this.qid,
              temp_id: this.tempId
            })
          );
          reLogin("template_id");
        } else {
          Toast(res.msg);
        }
      });
    },
    handleErr(url = "") {
      if (this.isInApp) {
        localStorage.setItem(
          "qid",
          JSON.stringify({
            qid: this.qid,
            type: 0
          })
        );
      }
      reLogin("qid", url);
    },
    // 获取排行信息
    getRank(data) {
      const l =
        data &&
        data.reduce((r, c) => {
          c.t_add = formatDate(new Date(c.t_add * 1000), "yyyy-MM-dd HH:mm");
          c.time = formatMinuteNew(c.time);
          return [...r, c];
        }, []);
      this.rankLists = l;
    },

    getDetailSecond() {
      questionOnly
        .get("/xcx/ques/v1/detail/second", {
          qid: this.qid,
          access_token: getToken(),
          loadingMsg: "no"
        })
        .then(res => {
          let d = res.data;
          let { show_rank, is_admin, is_vip, is_owner } = this.info;
          if (this.info.show_rank) {
            this.getRank(d.rank_list);
          } else if (!show_rank && (is_admin || is_vip || is_owner)) {
            this.getRank(d.rank_list);
          }
          if (d.record_lists && d.record_lists.length) {
            d.record_lists[0].time = formatMinuteNew(d.record_lists[0].time);
            d.record_lists[0].t_add = formatDate(
              new Date(d.record_lists[0].org_t_add * 1000),
              "yyyy-MM-dd HH:mm:ss",
              "sameYear"
            );
            d.record_lists[0].score = d.hide_score
              ? "-"
              : d.record_lists[0].score;
            d.record_lists[0].right = d.hide_score
              ? "-"
              : d.record_lists[0].right;
          }
          this.record_lists = d.record_lists;
          setTimeout(() => {
            this.showFooter = true;
          }, 500);
        });
    },
    handleStaging(d) {
      let { staging_data = {}, staging_switch } = d;
      this.staging_switch = staging_switch;
      this.staging_data = staging_data;
      let ques_storage = JSON.parse(localStorage.getItem(this.qid));
      if (
        ques_storage &&
        (!ques_storage.staging_data ||
          (ques_storage.staging_data &&
            !ques_storage.staging_data.rec_staging_id))
      ) {
        // 以前的方法
        this.pre_way = 1;
        return;
      } else if (!staging_switch) {
        // 开关关闭之后
        // 走老的方法
        if (
          staging_data &&
          JSON.stringify(staging_data) != "{}" &&
          ques_storage
        ) {
          let { status = 1, alert = 1 } = staging_data;
          if (!status) {
            // 有未提交的答题
            self.goOn = 1;
          } else if (!alert) {
            // 已提交但未提示
            if (staging_data.submit_type) {
              changeCacheStatus(this.qid, staging_data.rec_staging_id).then(
                () => {
                  this.judgeStagingInfo(staging_data);
                }
              );
            }
          }
        }
      } else if (staging_switch) {
        // 走新的
        if (
          ((JSON.stringify(staging_data) == "{}" ||
            (staging_data.status && staging_data.alert)) &&
            !ques_storage) ||
          (ques_storage &&
            staging_data.status &&
            staging_data.alert &&
            ques_storage.staging_switch)
        ) {
          // 如果没有暂存过的数据
          this.goOn = 0;
          if (ques_storage) localStorage.removeItem(this.qid);
        } else {
          if (!staging_data.status) {
            // 有未提交的答题
            this.goOn = 1;
          } else if (!staging_data.alert) {
            // 已提交但未提示
            if (staging_data.submit_type) {
              changeCacheStatus(this.qid, staging_data.rec_staging_id).then(
                () => {
                  this.judgeStagingInfo(staging_data);
                }
              );
            }
          }
        }
      }
    },
    judgeStagingInfo(staging_data, ifGoOn) {
      let { rid, submit_type, t_start, win } = staging_data;
      let content = "答题时间已截止，已为您自动提交";
      if (ifGoOn) {
        content =
          "该条记录已经提交过，无法重复提交，将根据先提交的内容统计得分";
      }
      if (submit_type == 1) {
        // 答题时间截止
        let prev_date = formatDate(t_start * 1000, "yyyy-MM-dd");
        content =
          "您在" +
          prev_date +
          "日答题内容未提交，已为您自动提交，再次进入可开始新的答题";
      }
      localStorage.removeItem(this.qid);
      Dialog.confirm({
        title: "",
        message: content,
        showCancelButton: false,
        confirmButtonText: "我知道了",
        confirmButtonColor: "#1890ff"
      })
        .then(() => {
          localStorage.removeItem(this.qid);
          if (win) {
            localStorage.setItem("_win", win);
          }
          this.$router.push({ name: "normalResult", query: { rid: rid } });
        })
        .catch(() => {});
    },
    toPcCreate() {
      window.open("https://xiaoxiaodati.com", "_blank");
    }
  }
};
</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px / 75 + rem;
}
main,
section,
article,
header,
footer {
  display: block;
}
h1 {
  margin: 0;
  font: inherit;
  color: inherit;
}
time {
  display: inline;
  font: inherit;
  color: inherit;
}
.blue {
  border-color: #1890ff;
  background: #1890ff;
}
.green {
  background: #07c160;
  border-color: #07c160;
}
.nomal-bg {
  background: #1890ff;
}
.all {
  min-height: 100vh;
  background: #f2f2f7;
  height: auto;
  position: relative;
  max-width: 500px;
  min-width: 320px;
  font-size: 14px;
  margin: 0 auto;
  transition: none;
  padding-bottom: env(safe-area-inset-bottom);
  .banner {
    width: 100%;
    max-height: 375px;
    display: block;
  }
  .main {
    background: #ffffff;
    .desc {
      color: #999;
    }
    .p30 {
      .title {
        font-weight: 700;
        font-size: 19px;
        color: #000;
        margin-bottom: 10px;
      }
      .pl20 {
        padding-left: 10px;
      }
    }
  }
  .owner {
    padding: 0 0 15px 0;
    display: flex;
    background: #ffffff;
    justify-content: space-between;
    align-items: center;
    .r {
      display: flex;
      align-items: center;
      .name {
        color: #000;
      }
    }
  }
  .join-number {
    font-size: 15px;
    color: #333;
    align-items: center;
    background-color: #fff;
    margin-top: 10px;
    .join-name {
      height: 45px;
      line-height: 45px;
      color: #333;
      padding: 0 15px;
    }
  }
  .foot {
    background: #ffffff;
    left: auto;
    max-width: 500px;
    min-width: 320px;
    border-top: 1px solid #eee;
    padding-bottom: env(safe-area-inset-bottom);
    z-index: 90;
  }
  .foot-btn {
    margin-left: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 63px;
    box-sizing: border-box;
    .choose {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .invite-btn {
      margin: 0 15px;
      font-size: 14px;
    }
    .handle-btns-left {
      display: flex;
      font-size: 12px;
      color: #262626;
      position: relative;
      justify-content: space-around;
      .item-div {
        margin-right: 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;
      }
      img {
        width: 22px;
        height: 22px;
        margin-bottom: 5px;
      }
    }
    .handle-btns-left > div:last-child {
      margin-right: 0;
    }
    .handle-btns-right {
      margin-left: 15px;
      display: flex;
      align-content: center;
      justify-content: center;
      color: white;
      font-size: 16px;
      position: relative;
      flex: 1;
    }
    .handle-btns-right > button {
      flex: 1;
    }
    &.template-foot {
      border-top: 1px solid #eee;
      padding: 15px 0;
      display: flex;
      height: auto;
    }
  }
}
.work-btn {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 16px;
  height: 43px;
  border-radius: 4px;
  margin-right: 15px;
}
.awards-tips {
  display: flex;
  color: #ff7070;
  font-weight: 900;
  padding-top: 5px;
  align-items: center;
}

.awards-tips img {
  width: 15px;
  height: 15px;
  margin-right: 4px;
}
.upgrage-wrapper {
  padding: 25px;
  font-size: 16px;
  text-align: center;
  color: #262626;
  .upgrage-title {
    line-height: 25px;
    margin-top: 15px;
  }
  .contact-btn {
    height: 43px;
    line-height: 43px;
    text-align: center;
    background: #1890ff;
    color: #fff;
    border-radius: 2px;
    font-size: 16px;
    margin: 20px auto;
  }
  .other-way {
    display: flex;
    color: #999999;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    margin-top: 20px;
    div {
      margin: 0 4px;
    }
    p {
      flex: 1;
      border-bottom: 1px dashed #999;
    }
  }
  .quesTitle {
    line-height: 21px;
    font-weight: 700;
    margin: 20px 0 15px;
  }
  .quesQrcode {
    width: 160px;
    height: 160px;
    object-fit: cover;
    margin: 0 auto 15px;
    display: block;
  }
  .upgrag-tip {
    display: inline-block;
    font-size: 14px;
    line-height: 21px;
    border: 1px dashed #ccc;
    padding: 6px 10px;
    color: #999;
  }
}
.statement-box {
  text-align: center;
  margin: 30px 0 0;
  padding-bottom: 84px;
  color: #999;
  font-size: 14px;
  span {
    cursor: pointer;
  }
}
.statement-box.active {
  padding-bottom: 90px;
}
.rules-box {
  padding: 15px 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
  color: #262626;
  margin-top: 3px;
  margin-bottom: 15px;
}
.rules-top {
  display: flex;
  align-items: center;
}
.rules_top_item {
  width: 25%;
  padding-left: 5px;
}
.rules_top_item_title {
  font-size: 13px;
  line-height: 18px;
  color: #999999;
}
.rules_top_item_text {
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
}
.rules_top_item_text.f30 {
  font-size: 15px;
}
.rules-content {
  font-size: 14px;
  line-height: 21px;
}
.rules-content-item {
  position: relative;
  padding-left: 15px;
  font-size: 13px;
  line-height: 21px;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.rules-content .rules-content-item:first-child {
  margin-top: 15px;
  border-top: 1px solid rgba(204, 204, 204, 0.3);
  padding-top: 15px;
}
.rules-content .rules-content-item:last-child {
  padding-bottom: 0;
}
.rules-content-item:before {
  position: absolute;
  left: 0;
  top: 8px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  content: "";
  background-color: #1890ff;
}
.rules-content .rules-content-item:first-child:before {
  top: 23px;
}
.tag-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.tag-item {
  height: 23px;
  line-height: 23px;
  padding: 0 10px;
  background: #eff7ff;
  border-radius: 50px;
  color: #1890ff;
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  margin-bottom: 12px;
  font-size: 12px;
}
.tag-item.red {
  background: rgba(168, 7, 26, 0.1);
  color: #a8071a;
}
.tag-item.gray {
  color: #999999;
  background: #f5f7fa;
}
.tag-icon {
  width: 13px;
  height: 13px;
  margin-right: 5px;
}
.owner-edit-desc {
  display: flex;
  align-items: center;
  color: #1890ff;
  font-size: 13px;
  margin-left: 5px;
  cursor: pointer;
}
.joiner-info {
  color: #666666;
  font-size: 14px;
  line-height: 22px;
  span {
    color: #1890ff;
  }
}
.rightCode-btn {
  margin-top: 24px;
}
.rightCode-btn button {
  display: block;
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  line-height: 48px;
  border-radius: 8px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.rightCode-btn .toCreate {
  color: #1890ff;
  background: #ffffff;
}
.levelname {
  height: 21px;
  line-height: 21px;
  padding-right: 10px;
  border-radius: 4px;
  margin-left: 10px;
  color: #999999;
  font-size: 14px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
}
.noAuth-pic {
  margin-top: 10px;
  text-align: center;
  background: #ffffff;
  padding: 20px 0 10px;
}
.noAuth-pic img {
  width: 220px;
  height: 220px;
  display: block;
  margin: 0 auto 15px;
}
.noAuth-pic span {
  display: inline-block;
  font-size: 14px;
  color: #999999;
  padding: 5px 10px;
  border: 1px dashed #cccccc;
}
.h5Link {
  background: #ffffff;
  box-sizing: border-box;
  font-size: 12px;
  position: relative;
  margin: 0 15px;
}

.h5Link-title {
  text-align: center;
  font-size: 17px;
  line-height: 25px;
  margin: 15px 0;
}

.h5Link-text {
  background: #f2f2f7;
  border-radius: 4px;
  padding: 10px;
  font-size: 15px;
  line-height: 21px;
  margin-bottom: 15px;
  word-break: break-all;
}

.h5Link-tip {
  font-size: 14px;
  line-height: 21px;
  color: #999;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.h5Link-tip-text {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #999999;
  margin-right: 5px;
}

.h5Link-tipActive-box {
  margin: 10px 0 0;
}

.h5Link-tipActive {
  line-height: 21px;
  color: #fa9d3b;
}

.h5Link-btn {
  height: 43px;
  line-height: 43px;
  background: #1890ff;
  border-radius: 2px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  margin: 15px 0;
}
.joiner_info {
  display: flex;
  align-items: center;
  font-size: 14px;
  background: #fff;
  padding: 5px 15px 10px;
}
.joiner_avatar {
  height: 30px;
  width: 30px;
  min-width: 30px;
  border-radius: 50%;
  margin-right: 5px;
  object-fit: cover;
}
.edit-joinername-box {
  position: relative;
  min-width: 89px;
  display: flex;
  align-items: center;
}
.edit-joinername {
  width: 15px;
  height: 15px;
  margin: 0 4px 0 10px;
}
.edit-text {
  color: #1890ff;
  cursor: pointer;
  min-width: 58px;
}
#launch-btn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  text-align: center;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
}
#launch-btn div {
  text-align: center;
}
#launch-btn-home {
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  font-size: 12px;
  text-align: left;
}
.home-wrap {
  margin-right: 20px;
}
.btn-homepage {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #999;
  height: 25px;
  margin-left: 10px;
  cursor: pointer;
}

.btn-homepage img {
  display: block;
  width: 8px;
  height: 12px;
  margin-left: 4px;
}
.msg-icon {
  width: 15px;
  height: 15px;
  min-width: 15px;
  margin-right: 2px;
}
.sec-desc {
  color: #999999;
  font-size: 12px;
  font-weight: normal;
}
.owner_avatar {
  width: 45px;
  height: 45px;
  border-radius: 4px;
  margin-right: 10px;
  object-fit: cover;
}
.leave-wrap {
  min-width: 42px;
  text-align: right;
}
.temp-btn {
  background: #1890ff;
  color: #ffffff;
  border: none;
  flex: 1;
  font-size: 15px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.work-content {
  position: relative;
  background-color: #fff;
  padding: 15px 15px 0;
  position: relative;
}
.content-top-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  padding: 10px 0 12px;
  line-height: 1.4;
}
.w100 {
  width: 100%;
  margin-right: 15px;
}

.shareimg-box {
  text-align: center;
  padding: 0 0 10px;
  img {
    width: 300px;
  }
  div {
    height: 30px;
    line-height: 30px;
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
    color: #fff;
  }
}
.level-tag {
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  padding: 1px 10px;
  display: inline-flex;
  align-items: center;
  background: #f5f7fa;
  font-size: 11px;
  color: #999;
  margin-right: 10px;
  margin-top: 8px;
}

.level-tag.active {
  background: linear-gradient(90deg, #d8ae7a -9.8%, #f5cea5 100%);
  color: #262626;
}

.level-tag .level-icon {
  width: 13px;
  height: 13px;
  margin-right: 4px;
}

.level-tag .level-icon-right {
  width: 8px;
  height: 8px;
  margin-left: 2px;
}
.vip-bg {
  background: #f5f7fa;
  padding: 0 10px;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  font-size: 11px;
  color: red;
  margin-right: 5px;
  margin-top: 8px;
}

.vip-bg-img {
  width: 11px;
  height: 11px;
  margin-right: 3px;
}
.eject-dialog-content {
  width: 100%;
  background: transparent;
  margin: 0 auto;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}

.eject-dialog-body {
  position: relative;
  width: 100%;
  max-width: 500px;
  padding: 20px 15px 0;
  background-color: #ffffff;
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
}

.eject-dialog-body .header-title {
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: #3d3d3d;
  margin-bottom: 20px;
}
.share-success-tip {
  font-size: 15px;
  color: #262626;
  margin: 0 0 15px;
  line-height: 20px;
}
.eject-dialog-body .ques-rules {
  padding: 10px;
  background: #f8f8f8;
  font-size: 14px;
}

.eject-dialog-body .rules-box {
  padding: 0;
  margin-bottom: 0;
}
.eject-dialog-content .cancel-button,
.eject-dialog-content .confirm-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #262626;
  border-radius: 20px;
  background: #f2f2f7;
  color: #262626;
  height: 40px;
  cursor: pointer;
}
.eject-dialog-content .confirm-button {
  background: #1890ff;
  color: #ffffff;
  margin-left: 10px;
}
.ready-tip {
  margin: 15px 0 20px;
  font-size: 15px;
}
.o-rules-item {
  display: flex;
  font-size: 15px;
  margin-top: 15px;
  line-height: 25px;
}

.rules-icon {
  width: 15px;
  height: 15px;
  min-width: 15px;
  margin-right: 5px;
  position: relative;
  top: 5px;
}
.share-count-tip {
  color: #ff8f1f;
}
.other-rules {
  border-top: 1px solid rgba(204, 204, 204, 0.3);
  margin-top: 15px;
}

.other-rules .o-rules-item:nth-child(2) {
  margin-top: 10px;
}
.nomal-bg {
  background: #1890ff;
}
.blue-arror-img {
  width: 8px;
  height: 12px;
  margin-left: 4px;
}
.blue-arror {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  color: #999999;
  line-height: 1;
  font-size: 14px;
}
.confirm-btn {
  margin-top: 20px;
}
.errTip {
  color: #ff7070;
  font-size: 13px;
  margin-top: 5px;
}
.pw-title {
  height: 21px;
  line-height: 21px;
  font-weight: bold;
  font-size: 15px;
}
.pw-remark {
  font-size: 15px;
  color: #999999;
  margin-top: 5px;
}
.pw-box {
  margin-bottom: 20px;
}

.password {
  height: 48px;
  border-radius: 4px;
  background: #f6f6f6;
  position: relative;
  box-sizing: border-box;
  margin-top: 10px;
}

.pass-input {
  height: 100%;
  padding: 15px 10px;
  box-sizing: border-box;
  font-size: 15px;
  border: none;
  width: 100%;
}
.password .clear {
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 10;
  transform: translate(0, -50%);
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.censor-box {
  text-align: center;
  background-color: #f2f2f7;
  min-height: 100%;
  padding-bottom: 15px;
  box-sizing: border-box;
  z-index: 100;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.bg-white {
  background: #fff;
  padding-bottom: 15px;
  margin-bottom: 10px;
}

.verifying_icon {
  width: 70px;
  height: 70px;
  margin-top: 50px;
}

.quick_verify {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.quick_verify_icon {
  width: 18px;
  height: 18px;
}

.quick_verify_text {
  text-decoration: underline;
  color: #1890ff;
  font-size: 14px;
}

.receive {
  height: 43px;
  line-height: 43px;
  text-align: center;
  border: 1px solid #1890ff;
  border-radius: 2px;
  font-size: 15px;
  margin: 15px 15px 0;
  color: #1890ff;
  box-sizing: border-box;
}

.aduit_service {
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  color: #ffffff;
  background: #1890ff;
  border-radius: 2px;
  margin: 25px 40px 0;
}

.btn-red,
.btn-censor {
  width: 138rpx;
  height: 30px;
  line-height: 30px;
  background: #ff7070;
  color: #fff;
  font-size: 14px;
  text-align: center;
  border-radius: 2px;
}

.btn-blue {
  background: #1890ff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 2px;
  height: 43px;
  /* width: 300rpx; */
  font-size: 15px;
  color: #fff;
}

.btn-censor {
  width: 300px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  margin-top: 30px;
}

.aduitBtnGroup {
  display: flex;
  margin: 0 25px;
}
.aduitBtnGroup .single-btn {
  background: #fff;
  border: 1px solid #1890ff;
  border-radius: 2px;
  color: #1890ff;
  flex: 1;
  font-size: 15px;
  height: 35px;
  line-height: 35px;
}
.buy-btn {
  flex: 1;
  margin-bottom: 15px;
}
.audit_desc {
  margin-bottom: 30px;
  padding: 0 25px;
}
.audit-service {
  position: absolute;
  bottom: 30px;
  left: 30px;
  right: 30px;
  font-size: 14px;
  color: #999999;
  cursor: pointer;
}
.ml30 {
  margin-left: 15px;
}
.censor-box.censor-box-audit {
  height: 100vh;
  background-color: #ffffff;
  position: relative;
  max-width: 500px;
}

.censor-desc {
  line-height: 1.6;
  font-size: 14px;
  color: #999;
  padding: 0 15px;
}
.censor-desc button {
  display: inline-block;
  color: #1890ff;
  margin: 0 5px;
  text-decoration: underline;
  font-size: 14px;
}
.censor-desc-pre {
  white-space: pre-line;
  word-break: break-all;
}
.censor-title {
  font-size: 18px;
  padding: 20px 0 10px;
}
.verifying-title {
  font-size: 18px;
  padding: 20px 0 20px;
}
.award-icon {
  width: 13px;
  height: 13px;
  margin-right: 4px;
}
.add-box {
  padding: 0 15px 15px;
  background: #fff;
}
.ad-mt {
  margin-top: 10px;
}
.ad-pt {
  padding-top: 15px;
}
.owner_avatar-box {
  display: inline-flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/normal/detail.vue